<template>
  <div class="pcd-field-date">
    <el-date-picker v-model="date" :value-format="valueFormat" :type="type" :size="size" :disabled="useCurrent === true"></el-date-picker>
    <el-button :size="size" :type="useCurrent === true ? 'primary' : 'default'" @click="useCurrentDate()">使用“当前时间”</el-button>
  </div>
</template>

<script>
export default {
  name: 'date-picker-field',
  props: {
    property: { type: Object, required: true },
    size: { type: String, required: false, default: 'mini' },
    valueFormat: { type: String, required: false, default: 'yyyy-MM-dd' },
    type: { type: String, required: false, default: 'date' }
  },
  data () {
    return {
      date: '',
      useCurrent: false
    }
  },
  watch: {
    'property.value': {
      handler: function (val) {
        if (val === true) {
          this.useCurrent = true
        } else {
          this.date = val
        }
      },
      immediate: true
    },
    date () {
      this.property.value = this.date
      this.$emit('change')
    }
  },
  methods: {
    useCurrentDate () {
      this.useCurrent = this.useCurrent === true ? false : true
      if (this.useCurrent === true) {
        this.property.value = true
      } else {
        this.property.value = this.date
      }
      this.$emit('change')
    }
  }
}
</script>

<style>
.pcd-field-date{position:relative;}
.pcd-field-date>.el-date-editor{width:calc(100% - 120px);}
.pcd-field-date>.el-button{width:120px;position:absolute;top:0;right:0;border-radius:0 4px 4px 0;}
</style>
